import Header from './Header.vue'
import Tags from './Tags.vue'
import Sidebar from './Sidebar.vue'

export class VHeader extends Header {}
export class VTags extends Tags {}
export class VSidebar extends Sidebar {}